/* eslint-disable max-lines */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable max-lines */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable complexity */
/* eslint-disable camelcase */
/* eslint-disable extra-rules/no-commented-out-code */
import ORDER_ITEM_TYPE from '@tcp/core/src/components/features/CnC/CartItemTile/CartItemTile.constants';
import AddItemsInNewBasketMutation from '@tcp/core/src/queries/addItemsInNewBasket.query.graphql';
import getCartCachedQuery from '@tcp/core/src/queries/getCartCached.query.graphql';
import addStoreItemsMutation from '@tcp/core/src/queries/addStoreItems.query.graphql';
import getBasketInventoryDetails from '@tcp/core/src/queries/getBasketInventory.query.graphql';
import { graphQlErrorHandler } from '@tcp/core/src/utils/errorMessage.util';
import { checkCache, isCanada } from '@tcp/core/src/utils';
import { executeStatefulGraphQLQuery } from '../../handler';
import { responseContainsErrors, ServiceResponseError } from '../../../utils/errorMessage.util';
import { getBrandInCaps } from '../../../utils';
import { parseBoolean } from '../../../utils/badge.util';
import { formatBundleData } from '../../../components/common/atoms/BundleTracker/util/utility';
import logger from '../../../utils/loggerInstance';
import { PRODUCT_ID_ERROR_TAG } from './AddedToBagConstant';

export const flatCurrencyToCents = (currency = 0) => {
  try {
    return parseFloat(parseFloat(currency.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]).toFixed(2));
  } catch (e) {
    throw new Error(e);
  }
};

const formatOrderItems = (items) => {
  const orderItems = [];
  items.forEach((item) => {
    orderItems.push({
      itemInfo: {
        quantity: parseInt(item.quantity, 10),
        itemId: item?.itemId.toString(),
        productId: item.productId,
        itemPoints: item.itemPoints || item.itemPoints === 0 ? parseInt(item.itemPoints, 10) : null,
        // This code is misleading - itemPrice and itemDstPrice are not equal to list price/offer price
        // Backend returns the same value for both itemPrice and itemDstPrice UNLESS an explicit promotion is applied
        // Enhancement needed - Backend should return the actual prices and frontend should determine which values to display

        listPrice: flatCurrencyToCents(item.basePrice),
        offerPrice: flatCurrencyToCents(item.priceAfterItemDiscount),
        backPackMessage: (item.priceAdjustments && item.priceAdjustments[0]?.itemText) || '',
        customizationType: item.c_customizationType,
        mainProduct: item.c_mainProduct,
        bundledProductItems: item?.bundledProductItems,
      },
    });
  });
  return orderItems;
};
export const formProdItemsWithLoyaltyAttr = (resp, params) => {
  const { LoyaltyPromoPLCCMultiplierStore, LoyaltyPromoMultiplierStore, productId } = params;
  const prodItemsWithLoyalty = resp.productItems || [];
  prodItemsWithLoyalty.forEach((prodItem) => {
    const item = prodItem;
    if (item.productId?.startsWith(productId)) {
      item.LoyaltyPromoMultiplierStore = LoyaltyPromoMultiplierStore;
      item.LoyaltyPromoPLCCMultiplierStore = LoyaltyPromoPLCCMultiplierStore;
    }
    item.TCPPromotions = prodItem?.c_bundlePromoId;
    return item;
  });
  return prodItemsWithLoyalty;
};

const getOrderTypes = (items) => {
  let obj = {};

  if (items) {
    let isBossOrder = items.find(
      (store) => store?.c_orderItemType?.toUpperCase() === ORDER_ITEM_TYPE.BOSS
    );
    let isBopisOrder = items.find(
      (store) => store?.c_orderItemType?.toUpperCase() === ORDER_ITEM_TYPE.BOPIS
    );
    let isECOM = items.find(
      (store) =>
        store?.c_orderItemType?.toUpperCase() === ORDER_ITEM_TYPE.ECOM || !store?.c_orderItemType
    );

    isBopisOrder = !!isBopisOrder;
    isBossOrder = !!isBossOrder;
    isECOM = !!isECOM;
    const isPickupOrder = isBopisOrder || isBossOrder;

    obj = {
      isBopisOrder,
      isBossOrder,
      isECOM,
      isPickupOrder,
    };
  }
  return obj;
};

const formatPromotions = () => {
  // Returning empty string as currently we don't get quantity value in new promotions. This is used for bundle tracker feature which is not live yet and we need to work on the change with new implementation before going live with bundle tracker feature.
  return '';

  // let TCPPromotions = '';
  // try {
  //   if (promotionResponse) {
  //     const promoArray = JSON.parse(promotionResponse);
  //     const keys = Object.keys(promoArray);
  //     keys.forEach((promoId) => {
  //       const quantity = promoArray[promoId]?.q || '';
  //       if (quantity === '') {
  //         TCPPromotions = '';
  //       }
  //       if (quantity) {
  //         if (TCPPromotions && TCPPromotions.length) {
  //           TCPPromotions += `,${promoId}:${quantity}`;
  //         } else {
  //           TCPPromotions += `${promoId}:${quantity}`;
  //         }
  //       }
  //     });
  //   }
  // } catch (error) {
  //   TCPPromotions = '';
  //   console.log(error);
  // }
  // return TCPPromotions;
};

const formatCustomizationType = (type) => {
  if (!type) {
    return null;
  }
  return type;
};

export const findSecondaryAccessoryId = (item, selectedSecondaryAccessories) => {
  const secondaryAccessories =
    selectedSecondaryAccessories &&
    selectedSecondaryAccessories.filter((secondaryAccessory) => {
      return secondaryAccessory.parentProductId === item.skuInfo.productId;
    });
  return (
    secondaryAccessories &&
    secondaryAccessories.map((accessory) => {
      return accessory?.skuInfo?.variantId;
    })
  );
};

export const findParentOfSecondaryAccessory = (parentProductId, selectedAccessories) => {
  const secondaryAccessories =
    selectedAccessories &&
    selectedAccessories.filter((item) => {
      return item?.skuInfo?.productId === parentProductId;
    });
  return secondaryAccessories && secondaryAccessories[0];
};

export const setPriceIncluded = (item, index, selectedAccessories, acc0007present, acc007arr) => {
  const idCheck = acc007arr && acc007arr[0];
  if (!acc0007present) {
    return index === 0 ? true : null;
  }
  if (
    acc0007present &&
    item?.skuInfo?.TCPStyleType === '0007' &&
    idCheck === item?.skuInfo?.variantId
  ) {
    return true;
  }
  return false;
};

const checkForBackPackCall = (selectedAccessories, payload) => {
  const { miscInfo } = payload || {};
  const { accessories } = miscInfo || [];
  const payloadAcc = (accessories && JSON.parse(JSON.stringify(accessories))) || [];
  return selectedAccessories?.length > 0 || (payloadAcc && payloadAcc?.length > 0);
};

const getCustomizationTypeFromSFL = (sflItems, productId) => {
  let customizationType = '';
  sflItems.map((item) => {
    if (item?.productInfo?.upc === productId) {
      customizationType = item?.miscInfo?.c_customizationType;
    }
    return null;
  });
  return customizationType;
};

const calcMainProducts = (mainProductsArray = [], parentId = '') => {
  let qty;
  const mainProduct = [];
  if (mainProductsArray) {
    mainProductsArray.map((id) => {
      if (id.includes(parentId)) {
        mainProduct.push(id);
        const hashed = id.split('#');
        [, qty] = hashed;
      }
      return null;
    });
  }
  return {
    qty,
    mainProduct,
  };
};

// eslint-disable-next-line complexity
const getRequestPayload = (
  params,
  selectedAccessories = [],
  customType = '',
  selectedSecondaryAccessories = [],
  sflListItems,
  originPage,
  payload
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  const {
    productId,
    quantity,
    productPartNo,
    multipackCatentryId,
    giftItem,
    size,
    fit,
    TCPStyleType,
    TCPStyleQTY,
    productUrl,
    productColor,
    TCPWebOnlyFlagStore,
    TCPProductIndStore,
    variantNo,
    brand = '',
    listPrice,
    wasPrice,
    bossDisabledFlags,
    isExtendedPreOrder,
    seoToken,
    isHardMarkEnabled,
  } = params;
  if (productId === '' || productId === null) {
    const errorData = `productPartNo: ${productPartNo}, size: ${size}, fit: ${fit},
    TCPStyleType: ${TCPStyleType}, productUrl: ${productUrl}, productColor: ${productColor},
    originPage: ${originPage}, variantNo: ${variantNo} `;
    logger.error(PRODUCT_ID_ERROR_TAG, { error: PRODUCT_ID_ERROR_TAG, extraData: errorData });
  }
  // const isAccSelected = selectedAccessories?.length > 0;
  const isBackPackCall = checkForBackPackCall(selectedAccessories, payload);
  const isSecondaryAccSelected = selectedSecondaryAccessories?.length > 0;
  if (!isBackPackCall) {
    const addItemsToBasketItems = {
      itemList: [
        {
          productId,
          quantity: Number(quantity),
          c_prodPartNo: productPartNo,
          c_brand: brand || getBrandInCaps(),
          c_multiPack: !!multipackCatentryId,
          c_multiPackItems: multipackCatentryId,
          c_giftOption: false,
          c_giftItem: giftItem,
          c_size: size,
          c_fit: fit,
          c_TCPStyleType: TCPStyleType || '',
          c_TCPStyleQTY: TCPStyleQTY || '',
          c_TCPWebOnlyFlagStore: parseBoolean(TCPWebOnlyFlagStore),
          c_TCPProductIndStore: TCPProductIndStore,
          c_TCPColor: productColor,
          c_TCPimages: productUrl,
          c_variant: variantNo,
          c_orderItemType: ORDER_ITEM_TYPE.ECOM,
          c_bundlePromoId: formatPromotions(),
          c_list_price: listPrice || wasPrice,
          c_itemTcpBossCategoryDisabled: bossDisabledFlags?.bossCategoryDisabled.toString(),
          c_itemTcpBossProductDisabled: bossDisabledFlags?.bossProductDisabled.toString(),
          c_seoToken: seoToken,
          c_isHardMarkEnabled: isHardMarkEnabled,
        },
      ],
    };
    let reqObject = {
      addItemsToBasketItems,
    };
    if (isExtendedPreOrder) {
      reqObject.addItemsToBasketItems.itemList[0].isExtendedPreOrder = true;
    }
    if (params.basketId) {
      reqObject = { ...reqObject };
    }
    return reqObject;
  }

  // this  payload created when Add to Bag is getting called in Move To Bag flow, here we have to do ADD_CALL.
  if (originPage === 'fromMoveToBag') {
    const { miscInfo, productInfo } = payload || {};
    const { upc: parentId } = productInfo;
    const { sflItems } = payload || [];
    const { accessories } = miscInfo || [];
    const payloadAcc = accessories && JSON.parse(JSON.stringify(accessories));
    const sflAccessoryPayload = [];
    for (let i = 0; i < payloadAcc.length; i += 1) {
      if (sflItems) {
        // eslint-disable-next-line no-loop-func
        sflItems.map((item) => {
          if (item?.productInfo?.upc === payloadAcc[i]) {
            sflAccessoryPayload.push({
              productId: item?.productInfo?.upc,
              quantity:
                Number(calcMainProducts(item?.miscInfo?.c_mainProducts, parentId)?.qty) || 1,
              c_prodPartNo: item?.productInfo?.productPartNumber,
              c_brand: brand || getBrandInCaps(),
              c_multiPack: null,
              c_multiPackItems: null,
              c_giftOption: false,
              c_giftItem: null,
              c_size: item?.productInfo?.size,
              c_fit: item?.productInfo?.fit,
              c_TCPStyleType: item?.productInfo?.tcpStyleTypeOriginal,
              c_TCPStyleQTY: item?.productInfo?.tcpStyleQty,
              c_TCPWebOnlyFlagStore: parseBoolean(item?.skuInfo?.TCPWebOnlyFlagStore),
              c_TCPProductIndStore: item?.skuInfo?.TCPProductIndStore,
              c_TCPColor: item?.skuInfo?.colorProductId || '',
              c_TCPimages: item?.skuInfo?.imageUrl || '',
              c_variant: item.skuInfo.variantId,
              c_orderItemType: ORDER_ITEM_TYPE.ECOM,
              c_mainProducts: calcMainProducts(item?.miscInfo?.c_mainProducts, parentId)
                ?.mainProduct,
              c_accessories: item?.miscInfo?.c_accessories,
              c_customizationType: item?.miscInfo?.c_customizationType,
              c_priceIncluded: item?.miscInfo?.c_priceIncluded,
              c_list_price: parseFloat(item?.itemInfo?.wasPrice),
              c_seoToken: seoToken,
              c_isHardMarkEnabled: isHardMarkEnabled,
            });
            const secondaryAccessories = item?.miscInfo?.c_accessories;
            const parentSecondary = item?.productInfo?.upc;
            if (secondaryAccessories) {
              for (let j = 0; j < secondaryAccessories.length; j += 1) {
                sflItems.map((secondaryAccItem) => {
                  if (secondaryAccItem?.productInfo?.upc === secondaryAccessories[j]) {
                    sflAccessoryPayload.push({
                      productId: secondaryAccItem?.productInfo?.upc,
                      quantity:
                        Number(
                          calcMainProducts(
                            secondaryAccItem?.miscInfo?.c_mainProducts,
                            parentSecondary
                          )?.qty
                        ) || 1,
                      c_prodPartNo: secondaryAccItem?.productInfo?.productPartNumber,
                      c_brand: brand || getBrandInCaps(),
                      c_multiPack: null,
                      c_multiPackItems: null,
                      c_giftOption: false,
                      c_giftItem: null,
                      c_size: secondaryAccItem?.productInfo?.size,
                      c_fit: secondaryAccItem?.productInfo?.fit,
                      c_TCPStyleType: secondaryAccItem?.productInfo?.tcpStyleTypeOriginal,
                      c_TCPStyleQTY: secondaryAccItem?.productInfo?.tcpStyleQty,
                      c_TCPWebOnlyFlagStore: parseBoolean(
                        secondaryAccItem?.skuInfo?.TCPWebOnlyFlagStore
                      ),
                      c_TCPProductIndStore: secondaryAccItem?.skuInfo?.TCPProductIndStore,
                      c_TCPColor: secondaryAccItem?.skuInfo?.colorProductId || '',
                      c_TCPimages: secondaryAccItem?.skuInfo?.imageUrl || '',
                      c_variant: secondaryAccItem.skuInfo.variantId,
                      c_orderItemType: ORDER_ITEM_TYPE.ECOM,
                      c_mainProducts: calcMainProducts(
                        secondaryAccItem?.miscInfo?.c_mainProducts,
                        parentSecondary
                      )?.mainProduct,
                      c_accessories: secondaryAccItem?.miscInfo?.c_accessories,
                      c_customizationType: secondaryAccItem?.miscInfo?.c_customizationType,
                      c_priceIncluded: secondaryAccItem?.miscInfo?.c_priceIncluded,
                      c_list_price: parseFloat(secondaryAccItem?.itemInfo?.wasPrice),
                      c_seoToken: seoToken,
                      c_isHardMarkEnabled: isHardMarkEnabled,
                    });
                  }
                  return null;
                });
              }
            }
          }
          return null;
        });
      }
    }
    let addItemsToBasketItems = {
      itemList: [
        {
          productId,
          quantity: Number(quantity),
          c_prodPartNo: productPartNo,
          c_brand: brand || getBrandInCaps(),
          c_multiPack: !!multipackCatentryId,
          c_multiPackItems: multipackCatentryId,
          c_giftOption: false,
          c_giftItem: giftItem,
          c_size: size && size.toString(),
          c_fit: fit && fit.toString(),
          c_TCPStyleType: TCPStyleType || '',
          c_TCPStyleQTY: TCPStyleQTY || '',
          c_TCPWebOnlyFlagStore: parseBoolean(TCPWebOnlyFlagStore),
          c_TCPProductIndStore: TCPProductIndStore,
          c_TCPColor: productColor,
          c_TCPimages: productUrl,
          c_variant: variantNo,
          c_orderItemType: ORDER_ITEM_TYPE.ECOM,
          c_accessories: payloadAcc,
          c_bundlePromoId: formatPromotions(),
          c_customizationType: getCustomizationTypeFromSFL(sflItems, productId),
          c_list_price: listPrice || wasPrice,
          c_seoToken: seoToken,
          c_isHardMarkEnabled: isHardMarkEnabled,
        },
      ],
    };
    addItemsToBasketItems = {
      itemList: [...addItemsToBasketItems.itemList, ...sflAccessoryPayload],
    };

    let reqObject = {
      addItemsToBasketItems,
    };
    if (params.basketId) {
      reqObject = { ...reqObject };
    }
    return reqObject;
  }

  const accessoryItemArray =
    isBackPackCall &&
    selectedAccessories &&
    selectedAccessories.map((item) => {
      return item.skuInfo.variantId;
    });

  let acc0007present = false;
  const acc007arr = [];
  selectedAccessories.forEach((item) => {
    if (item.skuInfo.TCPStyleType === '0007') {
      acc0007present = true;
      acc007arr.push(item?.skuInfo?.variantId);
    }
  });
  const accessoryItems =
    isBackPackCall &&
    selectedAccessories &&
    selectedAccessories.map((item, index) => {
      const secondaryAccessoryItem = findSecondaryAccessoryId(item, selectedSecondaryAccessories);
      const isIncluded =
        customType === 'mandatory'
          ? setPriceIncluded(item, index, selectedAccessories, acc0007present, acc007arr)
          : false;
      return {
        productId: item.skuInfo.variantId,
        quantity: Number(item.quantity),
        c_prodPartNo: item.skuInfo.prodPartNo,
        c_brand: brand || getBrandInCaps(),
        c_multiPack: null,
        c_multiPackItems: null,
        c_giftOption: false,
        c_giftItem: null,
        c_size: item.skuInfo.size,
        c_fit: item.skuInfo.fit,
        c_TCPStyleType: item.skuInfo.TCPStyleType || '',
        c_TCPStyleQTY: item.skuInfo.TCPStyleQTY || '',
        c_TCPWebOnlyFlagStore: parseBoolean(item.skuInfo.TCPWebOnlyFlagStore),
        c_TCPProductIndStore: item.skuInfo.TCPProductIndStore,
        c_TCPColor: item?.skuInfo?.color?.family || '',
        c_TCPimages: item?.skuInfo?.imageUrl || '',
        c_variant: item.skuInfo.variantNo,
        c_orderItemType: ORDER_ITEM_TYPE.ECOM,
        c_mainProducts: [`${productId}#${Number(item.quantity)}#${isIncluded}`],
        c_accessories: secondaryAccessoryItem,
        c_customizationType:
          secondaryAccessoryItem && secondaryAccessoryItem.length ? 'mandatory' : null,
        c_priceIncluded: isIncluded,
        c_list_price: item?.skuInfo?.listPrice || 0,
        c_seoToken: seoToken,
        c_isHardMarkEnabled: isHardMarkEnabled,
      };
    });

  const secondaryAccessoryItems =
    isSecondaryAccSelected &&
    selectedSecondaryAccessories.map((item) => {
      const { skuInfo } = item;
      const { variantId } = skuInfo;
      const primaryAccessory = findParentOfSecondaryAccessory(
        item.parentProductId,
        selectedAccessories
      );
      const secondaryAccessoryItem = findSecondaryAccessoryId(
        primaryAccessory,
        selectedSecondaryAccessories
      );
      const isIncluded = secondaryAccessoryItem.indexOf(variantId) === 0;
      return {
        productId: variantId,
        quantity: Number(item.quantity),
        c_prodPartNo: item.skuInfo.prodPartNo,
        c_brand: brand || getBrandInCaps(),
        c_multiPack: null,
        c_multiPackItems: null,
        c_giftOption: false,
        c_giftItem: null,
        c_size: item.skuInfo.size,
        c_fit: item.skuInfo.fit,
        c_TCPStyleType: item.skuInfo.TCPStyleType || '',
        c_TCPStyleQTY: item.skuInfo.TCPStyleQTY || '',
        c_TCPWebOnlyFlagStore: parseBoolean(item.skuInfo.TCPWebOnlyFlagStore),
        c_TCPProductIndStore: item.skuInfo.TCPProductIndStore,
        c_TCPColor: item?.skuInfo?.color?.family || '',
        c_TCPimages: item?.skuInfo?.imageUrl || '',
        c_variant: item.skuInfo.variantNo,
        c_orderItemType: ORDER_ITEM_TYPE.ECOM,
        c_mainProducts: [
          `${primaryAccessory?.skuInfo?.variantId}#${Number(item.quantity)}#${isIncluded}`,
        ],
        c_priceIncluded: isIncluded,
        c_list_price: item?.skuInfo?.listPrice || 0,
        c_seoToken: seoToken,
        c_isHardMarkEnabled: isHardMarkEnabled,
      };
    });

  let addItemsToBasketItems = {
    itemList: [
      {
        productId,
        quantity: Number(quantity),
        c_prodPartNo: productPartNo,
        c_brand: brand || getBrandInCaps(),
        c_multiPack: !!multipackCatentryId,
        c_multiPackItems: multipackCatentryId,
        c_giftOption: false,
        c_giftItem: giftItem,
        c_size: size && size.toString(),
        c_fit: fit && fit.toString(),
        c_TCPStyleType: TCPStyleType || '',
        c_TCPStyleQTY: TCPStyleQTY || '',
        c_TCPWebOnlyFlagStore: parseBoolean(TCPWebOnlyFlagStore),
        c_TCPProductIndStore: TCPProductIndStore,
        c_TCPColor: productColor,
        c_TCPimages: productUrl,
        c_variant: variantNo,
        c_orderItemType: ORDER_ITEM_TYPE.ECOM,
        c_accessories: accessoryItemArray,
        c_bundlePromoId: formatPromotions(),
        c_customizationType: formatCustomizationType(customType),
        c_list_price: listPrice,
        c_seoToken: seoToken,
        c_isHardMarkEnabled: isHardMarkEnabled,
      },
    ],
  };

  if (isExtendedPreOrder) {
    addItemsToBasketItems.itemList[0].isExtendedPreOrder = true;
  }

  if (secondaryAccessoryItems && secondaryAccessoryItems?.length) {
    addItemsToBasketItems = {
      itemList: [...addItemsToBasketItems.itemList, ...accessoryItems, ...secondaryAccessoryItems],
    };
  } else {
    addItemsToBasketItems = {
      itemList: [...addItemsToBasketItems.itemList, ...accessoryItems],
    };
  }

  let reqObject = {
    addItemsToBasketItems,
  };
  if (params.basketId) {
    reqObject = { ...reqObject };
  }
  return reqObject;
};

const extractCountryBasedAttributes = (type, qty, webOnly, productInd, cbParams) => {
  const {
    LoyaltyPromoPLCCMultiplierStore = '',
    LoyaltyPromoMultiplierStore = '',
    preOrderDate = '',
  } = cbParams || {};
  const isCASite = isCanada();
  return {
    styleQtyCA: isCASite ? qty : 0,
    styleQtyUS: !isCASite ? qty : 0,
    styleTypeCA: isCASite ? type : 0,
    styleTypeUS: !isCASite ? type : 0,
    webOnlyFlagCanadaStore: isCASite ? webOnly : false,
    webOnlyFlagUSStore: !isCASite ? webOnly : false,
    productIndCanadaStore: isCASite ? productInd : '',
    productIndUSStore: !isCASite ? productInd : '',
    loyaltyPromoMultiplierCAStore: isCASite ? LoyaltyPromoMultiplierStore : '',
    loyaltyPromoMultiplierUSStore: !isCASite ? LoyaltyPromoMultiplierStore : '',
    loyaltyPromoPLCCMultiplierCAStore: isCASite ? LoyaltyPromoPLCCMultiplierStore : '',
    loyaltyPromoPLCCMultiplierUSStore: !isCASite ? LoyaltyPromoPLCCMultiplierStore : '',
    tcpPreOrderDateUSStore: !isCASite ? preOrderDate : '',
    variantPreOrderDateUS: null,
    variantPreOrderDateCA: null,
  };
};
const formInvObj = (prodObj, cbParams) => {
  const {
    productId,
    productName,
    quantity: requestedQty,
    c_size: size,
    c_fit: fit,
    c_TCPStyleType: tcpStyleType,
    c_TCPStyleQTY: tcpStyleQTY,
    c_TCPWebOnlyFlagStore: webOnlyFlagStore,
    c_TCPProductIndStore: productIndStore = null,
    c_TCPColor: color,
    c_TCPimages: imageUrl,
    c_fromStoreId: storeId,
    c_list_price: listPrice,
    c_isHardMarkEnabled: isHardMarkEnabled,
  } = prodObj;
  const countryBasedAttributes = extractCountryBasedAttributes(
    tcpStyleType,
    tcpStyleQTY,
    webOnlyFlagStore,
    productIndStore,
    cbParams
  );

  return {
    productId,
    requestedQty,
    size,
    upc: productId,
    availableQty: requestedQty,
    bossAvailableQty: requestedQty,
    bopisInventory: {
      atcQuantity: requestedQty,
      atcStatus: 'AVAILABLE',
      facilityName: storeId,
      itemName: productId,
      __typename: 'BOPISInventoryDTO',
    },
    color,
    fit,
    imageUrl,
    outOfStock: false,
    ...countryBasedAttributes,
    productName,
    listPrice,
    isHardMarkEnabled,
    __typename: 'InventoryProductList',
  };
};

const updateExistingItems = (data, itemArray, cbParams) => {
  const { productId } = cbParams || {};
  const updatedData = data && data.productItems.find((itm) => itm.productId?.startsWith(productId));

  const invObj = formInvObj(updatedData, cbParams);
  return itemArray.map((rcd) => {
    if (rcd.productId === productId) {
      return {
        ...rcd,
        ...invObj,
      };
    }
    return rcd;
  });
};
const addNewItem = (data, cbParams, InvArr) => {
  const newInvArr = InvArr;
  const { productId: prodId } = cbParams || {};
  const newData = data && data.productItems.find((itm) => itm.productId?.startsWith(prodId));
  if (newData) {
    const invObj = formInvObj(newData, cbParams);
    newInvArr.push({ ...invObj, online: true });
  }
  return newInvArr;
};

const getStoreBody = (data) => {
  const { shipments } = data;
  let storeDetails = [];
  if (shipments) {
    storeDetails = shipments
      .filter((ship) => !!ship.c_fromStoreId === true)
      .map((method) => {
        const { bossMaxDate, bossMinDate, c_fromStoreId, shippingAddress } = method;
        const {
          address1,
          address2,
          c_emailAddress: email,
          c_storeHours: storeHours,
          c_storeName: name,
          city,
          countryCode,
          isStoreBOSSEligible: cIsStoreBossEligible,
          phone,
          postalCode,
          stateCode,
        } = shippingAddress;

        return {
          address1,
          address2,
          bossMaxDate,
          bossMinDate,
          cIsStoreBossEligible,
          city,
          countryCode,
          email,
          id: c_fromStoreId,
          name,
          phone,
          postalCode,
          stateCode,
          storeHours,
          __typename: 'MinimalStoreDetailsDTO',
        };
      });
  }
  return storeDetails;
};

const prepareInvData = (baseData, data, cbParams) => {
  const { productId: prodId } = cbParams || {};
  const inventoryData = baseData?.getBasketInventoryDetails || {};
  const { productList = [] } = inventoryData;
  let updatedList = [];

  const updateList = (id) => {
    const isItemExist = productList.find((itm) => itm.productId === id);
    if (isItemExist) {
      updatedList = updateExistingItems(data, productList, { ...cbParams, productId: id });
    } else {
      updatedList = addNewItem(data, { ...cbParams, productId: id }, productList);
    }
  };

  if (Array.isArray(prodId)) {
    prodId.forEach((id) => {
      updateList(id);
    });
  } else {
    updateList(prodId);
  }

  const storeDetails = getStoreBody(data);
  return {
    ...inventoryData,
    productList: updatedList,
    storeDetails,
    __typename: 'InventoryResponseDTO',
  };
};

export const updateInventory = (cache, data, cbParams) => {
  const isCacheExist = checkCache(cache, 'getBasketInventoryDetails');
  try {
    if (isCacheExist) {
      const storedData = cache.readQuery({ query: getBasketInventoryDetails });
      const inventoryData = prepareInvData(storedData, data, cbParams);
      cache.writeQuery({
        query: getBasketInventoryDetails,
        data: { getBasketInventoryDetails: inventoryData },
        // broadcast: false,
      });
    }
  } catch (err) {
    // https://childrensplace.atlassian.net/browse/DRP-38015
    // To Handle old cart with corrupted data, don't throw the error, let
    // GET_INVENTORY_CALL happen
    // throw new Error(err);
  }
};
// eslint-disable-next-line complexity
export const updateQuery = (cache, data, cbParams) => {
  const { shipments, ...dataToUpdate } =
    data && (data.addItemsInNewBasket || data.addItemsToBasket || data.addStoreItems);
  let isCacheExist = false;
  try {
    if (Object.keys(dataToUpdate).length) {
      isCacheExist = checkCache(cache);
    }
    if (isCacheExist && dataToUpdate) {
      cache.writeQuery({
        query: getCartCachedQuery,
        data: { getCart: dataToUpdate },
        // broadcast: false,
      });
      if (Array.isArray(cbParams)) {
        // eslint-disable-next-line no-restricted-syntax
        for (const i of cbParams) {
          updateInventory(cache, { shipments, ...dataToUpdate }, i);
        }
      } else {
        updateInventory(cache, { shipments, ...dataToUpdate }, cbParams);
      }
    }
  } catch (err) {
    throw new Error(err);
  }
};

const filterRecentlyAddedItem = (productArray, recentProduct) => {
  const filteredValue = productArray.filter((value) => {
    return value.productId?.startsWith(recentProduct);
  });
  return filteredValue[0];
};

export const addMultipleProductsInEcom = (paramsArray, errorMapping) => {
  const atbSuccessProducts = [];
  let respToProcess = {};
  return paramsArray.reduce((initialSynchPromise, params, index) => {
    return initialSynchPromise.then(() => {
      const reqObject = getRequestPayload(params);
      const {
        LoyaltyPromoPLCCMultiplierStore,
        LoyaltyPromoMultiplierStore,
        productId,
        preOrderDate = '',
      } = params;
      const callbackParams = {
        LoyaltyPromoPLCCMultiplierStore,
        LoyaltyPromoMultiplierStore,
        productId,
        preOrderDate,
      };
      // SFCC-TODO: Remove additional passed parameters(null, true)
      return executeStatefulGraphQLQuery({
        query: AddItemsInNewBasketMutation,
        variables: reqObject,
        type: 'mutation',
        callbackParams,
        updateQuery,
      })
        .then((response) => {
          const { addItemsInNewBasket } = response.data;
          let addToBasketResp = {};
          if (response.data && addItemsInNewBasket) {
            addToBasketResp = addItemsInNewBasket;
          } else if (responseContainsErrors({ res: { body: response } })) {
            throw new ServiceResponseError({ res: { body: response } });
          }
          const loyaltyOrderItems = formProdItemsWithLoyaltyAttr(addToBasketResp, params);
          const isLastProduct = paramsArray.length === index + 1;
          respToProcess = {
            ...addToBasketResp,
            productItems: loyaltyOrderItems,
          };

          const recentProduct = filterRecentlyAddedItem(
            addToBasketResp.productItems,
            params.productId
          );

          atbSuccessProducts.push({
            orderId: addToBasketResp.basketId,
            orderItemId: addToBasketResp.productItems && recentProduct?.itemId,
            basketId: addToBasketResp.basketId,
            basketError: addToBasketResp.basketError,
            orderTotal: addToBasketResp.productTotal,
            orderItemTotal: addToBasketResp.productTotal, // confirm mapping SFCC-TODO
            orderItems:
              addToBasketResp.productItems && formatOrderItems(addToBasketResp.productItems),
            estimatedRewards: 0,
            isBrierleyWorking: false,
            grandTotal: flatCurrencyToCents(addToBasketResp.productTotal),
            pointsToNextReward: addToBasketResp.pointsToNextReward || 0,
            totalItems: addToBasketResp.productItems.length || 0,
            giftCardsTotal: addToBasketResp.totalGiftCardAmount,
            earnedReward: addToBasketResp.earnedReward,
            cartTotalAfterPLCCDiscount: flatCurrencyToCents(
              addToBasketResp.c_cartTotalAfterPLCCDiscount || 0
            ),
            orderSubTotalDiscount: addToBasketResp.productSubTotal,
            loyaltyOrderItems,
            isElectiveBonus: '',
            orderSubTotal: '',
            orderSubTotalBeforeDiscount: addToBasketResp.orderSubTotalBeforeDiscount,
            orderSubTotalWithoutGiftCard: addToBasketResp.orderSubTotalWithoutGiftCard,
            orderTotalAfterDiscount: '',
            orderTotalListPrice: '',
            orderTotalSaving: addToBasketResp.orderTotalSaving,
            mprId: '',
            loyaltyCallEnabled: false,
            pointsApi: '',
            ...getOrderTypes(addToBasketResp.productItems),
            ...params.product,
            ...(isLastProduct && { respToProcess }),
          });
          return atbSuccessProducts;
        })
        .catch((err) => {
          // eslint-disable-next-line no-throw-literal
          throw {
            error: graphQlErrorHandler(err, errorMapping),
            errorProductId: params.productPartNo,
            atbSuccessProducts,
            respToProcess,
          };
        });
    });
  }, Promise.resolve());
};

const calculateTotalItems = (data) => {
  let sum = 0;
  // eslint-disable-next-line no-restricted-syntax
  for (const i of data) {
    sum += i.quantity;
  }
  return sum;
};

export const addCartEcomItem = (
  params,
  errorMapping,
  selectedAccessories = [],
  customType = '',
  selectedSecondaryAccessories = [],
  sflParams
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  const { sflListItems } = sflParams || [];
  const { originPage } = sflParams || '';
  const { payload } = sflParams || {};
  const { orderItems, bundleDataItems } = sflParams || [];
  const { isBundleTracker } = sflParams || false;
  const reqObject = getRequestPayload(
    params,
    selectedAccessories,
    customType,
    selectedSecondaryAccessories,
    sflListItems,
    originPage,
    payload
  );
  const {
    LoyaltyPromoPLCCMultiplierStore,
    LoyaltyPromoMultiplierStore,
    productId,
    preOrderDate = '',
    accessories = [],
  } = params;
  const ids = [productId];
  if (accessories && accessories.length) {
    accessories.forEach((accessory) => {
      const { skuInfo = {} } = accessory || {};
      const { variantId } = skuInfo;
      return ids.push(variantId);
    });
  }
  const callbackParams = {
    LoyaltyPromoPLCCMultiplierStore,
    LoyaltyPromoMultiplierStore,
    productId: ids,
    preOrderDate,
    accessories,
  };
  // SFCC-TODO: Remove additional passed parameters(null, true)
  return executeStatefulGraphQLQuery({
    query: AddItemsInNewBasketMutation,
    variables: reqObject,
    callbackParams,
    type: 'mutation',
    // context: { timeout: 2000 }, // example for timeout (in ms)
    updateQuery,
  })
    .then((response) => {
      let addToBasketResp = {};
      const { addItemsInNewBasket } = response.data;
      if (response.data && addItemsInNewBasket) {
        addToBasketResp = addItemsInNewBasket;
      } else if (responseContainsErrors({ res: { body: response } })) {
        throw new ServiceResponseError({ res: { body: response } });
      }
      const recentProduct = filterRecentlyAddedItem(addToBasketResp.productItems, params.productId);
      // SFCC-TODO
      return {
        basketId: addToBasketResp.basketId,
        orderId: addToBasketResp.basketId,
        orderItemId: addToBasketResp.productItems && recentProduct?.itemId,
        orderTotal: addToBasketResp.productTotal,
        orderItemTotal: addToBasketResp.productTotal, // confirm mapping SFCC-TODO
        orderItems: addToBasketResp.productItems && formatOrderItems(addToBasketResp.productItems),
        estimatedRewards: 0,
        isBrierleyWorking: false,
        grandTotal: flatCurrencyToCents(addToBasketResp.productTotal),
        pointsToNextReward: addToBasketResp.pointsToNextReward || 0,
        totalItems: calculateTotalItems(addToBasketResp.productItems) || 0,
        giftCardsTotal: addToBasketResp.totalGiftCardAmount, // need to come from SFCC // SFCC-TODO
        earnedReward: addToBasketResp.earnedReward, // need to come from SFCC // SFCC-TODO
        cartTotalAfterPLCCDiscount: flatCurrencyToCents(
          addToBasketResp.c_cartTotalAfterPLCCDiscount || 0
        ), // need to come from SFCC // SFCC-TODO
        orderSubTotalDiscount: addToBasketResp.productSubTotal,
        loyaltyOrderItems: formProdItemsWithLoyaltyAttr(addToBasketResp, params),
        isElectiveBonus: '',
        orderSubTotal: '',
        orderSubTotalBeforeDiscount: addToBasketResp.orderSubTotalBeforeDiscount, // need to come from SFCC // SFCC-TODO
        orderSubTotalWithoutGiftCard: addToBasketResp.orderSubTotalWithoutGiftCard, // need to come from SFCC // SFCC-TODO
        orderTotalAfterDiscount: '',
        orderTotalListPrice: '',
        orderTotalSaving: addToBasketResp.orderTotalSaving, // need to come from SFCC // SFCC-TODO
        mprId: '',
        loyaltyCallEnabled: false,
        pointsApi: '',
        ...getOrderTypes(addToBasketResp.productItems), // in product item, orderItemType attribute not available // SFCC-TODO
        addToBasketResp: {
          ...addToBasketResp,
          productItems: formProdItemsWithLoyaltyAttr(addToBasketResp, params),
        }, // this resp is returned to update cart.
        bundleData: isBundleTracker
          ? formatBundleData(response, orderItems, bundleDataItems)
          : null,
      };
    })
    .catch((err) => {
      throw graphQlErrorHandler(err, errorMapping);
    });
};

export const addCartBopisItem = (
  params,
  errorMapping,
  {
    orderItems = [],
    bundleDataItems = [],
    isBundleTracker = false,
    selectedAccessories = [],
    customType = '',
    selectedSecondaryAccessories = [],
    payload = {},
  }
) => {
  const {
    LoyaltyPromoPLCCMultiplierStore,
    LoyaltyPromoMultiplierStore,
    productId,
    preOrderDate = '',
    accessories = [],
    seoToken,
    hardMarkDown,
  } = params;
  const ids = [productId];
  if (accessories && accessories.length) {
    accessories.forEach((accessory) => {
      const { skuInfo = {} } = accessory || {};
      const { variantId } = skuInfo;
      return ids.push(variantId);
    });
  }
  const callbackParams = {
    LoyaltyPromoPLCCMultiplierStore,
    LoyaltyPromoMultiplierStore,
    productId: ids,
    preOrderDate,
    accessories,
  };
  let queryPayload = {};
  const isBackPackCall = checkForBackPackCall(selectedAccessories, payload);
  const isSecondaryAccSelected = selectedSecondaryAccessories?.length > 0;
  const { bossDisabledFlags } = params || {};
  if (!isBackPackCall) {
    queryPayload = {
      items: {
        itemList: [
          {
            cFromStoreId: params?.storeLocId,
            c_prodPartNo: params?.productPartNo,
            productId: params?.itemPartNumber,
            quantity: Number(params.quantity),
            shipmentId: params?.pickupType.toUpperCase(),
            c_TCPimages: params?.productUrl,
            c_variant: params?.variantNo,
            c_giftOption: false,
            c_giftItem: params?.giftItem,
            c_size: params?.size,
            c_brand: params?.brand || getBrandInCaps(),
            c_TCPColor: params?.productColor,
            c_fit: params?.fit,
            c_multiPack: !!params?.multipackCatentryId,
            c_multiPackItems: params?.multipackCatentryId,
            c_TCPStyleType: params?.TCPStyleType || '',
            c_TCPStyleQTY: params?.TCPStyleQTY || '',
            c_TCPWebOnlyFlagStore: parseBoolean(params?.TCPWebOnlyFlagStore),
            c_TCPProductIndStore: params?.TCPProductIndStore || '',
            c_orderItemType: params?.pickupType.toUpperCase(),
            c_list_price: params?.listPrice,
            c_bundlePromoId: formatPromotions(),
            c_itemTcpBossCategoryDisabled: bossDisabledFlags?.bossCategoryDisabled.toString(),
            c_itemTcpBossProductDisabled: bossDisabledFlags?.bossProductDisabled.toString(),
            c_seoToken: seoToken,
            c_isHardMarkEnabled: parseBoolean(hardMarkDown),
          },
        ],
      },
    };
  }

  const accessoryItemArray =
    isBackPackCall &&
    selectedAccessories &&
    selectedAccessories.map((item) => {
      return item.skuInfo.variantId;
    });

  let acc0007present = false;
  const acc007arr = [];
  // eslint-disable-next-line sonarjs/no-identical-functions
  selectedAccessories.forEach((item) => {
    if (item.skuInfo.TCPStyleType === '0007') {
      acc0007present = true;
      acc007arr.push(item?.skuInfo?.variantId);
    }
  });
  const accessoryItems =
    isBackPackCall &&
    selectedAccessories &&
    selectedAccessories.map((item, index) => {
      const secondaryAccessoryItem = findSecondaryAccessoryId(item, selectedSecondaryAccessories);
      const isIncluded =
        customType === 'mandatory'
          ? setPriceIncluded(item, index, selectedAccessories, acc0007present, acc007arr)
          : false;
      return {
        cFromStoreId: params?.storeLocId,
        shipmentId: params?.pickupType.toUpperCase(),
        c_orderItemType: params?.pickupType.toUpperCase(),
        productId: item.skuInfo.variantId,
        quantity: Number(item.quantity),
        c_prodPartNo: item.skuInfo.prodPartNo,
        c_brand: params?.brand || getBrandInCaps(),
        c_multiPack: null,
        c_multiPackItems: null,
        c_giftOption: false,
        c_giftItem: null,
        c_size: item.skuInfo.size,
        c_fit: item.skuInfo.fit,
        c_TCPStyleType: item.skuInfo.TCPStyleType || '',
        c_TCPStyleQTY: item.skuInfo.TCPStyleQTY || '',
        c_TCPWebOnlyFlagStore: parseBoolean(item.skuInfo.TCPWebOnlyFlagStore),
        c_TCPProductIndStore: item.skuInfo.TCPProductIndStore,
        c_TCPColor: item?.skuInfo?.color?.family || '',
        c_TCPimages: item?.skuInfo?.imageUrl || '',
        c_variant: item.skuInfo.variantNo,
        c_mainProducts: [`${productId}#${Number(item.quantity)}#${isIncluded}`],
        c_accessories: secondaryAccessoryItem,
        c_customizationType:
          secondaryAccessoryItem && secondaryAccessoryItem.length ? 'mandatory' : null,
        c_priceIncluded: isIncluded,
        c_list_price: item?.skuInfo?.listPrice || 0,
        c_itemTcpBossCategoryDisabled: bossDisabledFlags?.bossCategoryDisabled.toString(),
        c_itemTcpBossProductDisabled: bossDisabledFlags?.bossProductDisabled.toString(),
        c_seoToken: seoToken,
        c_isHardMarkEnabled: parseBoolean(hardMarkDown),
      };
    });

  const secondaryAccessoryItems =
    isSecondaryAccSelected &&
    selectedSecondaryAccessories.map((item) => {
      const { skuInfo } = item;
      const { variantId } = skuInfo;
      const primaryAccessory = findParentOfSecondaryAccessory(
        item.parentProductId,
        selectedAccessories
      );
      const secondaryAccessoryItem = findSecondaryAccessoryId(
        primaryAccessory,
        selectedSecondaryAccessories
      );
      const isIncluded = secondaryAccessoryItem.indexOf(variantId) === 0;
      return {
        cFromStoreId: params?.storeLocId,
        shipmentId: params?.pickupType.toUpperCase(),
        c_orderItemType: params?.pickupType.toUpperCase(),
        productId: variantId,
        quantity: Number(item.quantity),
        c_prodPartNo: item.skuInfo.prodPartNo,
        c_brand: params?.brand || getBrandInCaps(),
        c_multiPack: null,
        c_multiPackItems: null,
        c_giftOption: false,
        c_giftItem: null,
        c_size: item.skuInfo.size,
        c_fit: item.skuInfo.fit,
        c_TCPStyleType: item.skuInfo.TCPStyleType || '',
        c_TCPStyleQTY: item.skuInfo.TCPStyleQTY || '',
        c_TCPWebOnlyFlagStore: parseBoolean(item.skuInfo.TCPWebOnlyFlagStore),
        c_TCPProductIndStore: item.skuInfo.TCPProductIndStore,
        c_TCPColor: item?.skuInfo?.color?.family || '',
        c_TCPimages: item?.skuInfo?.imageUrl || '',
        c_variant: item.skuInfo.variantNo,
        c_mainProducts: [
          `${primaryAccessory?.skuInfo?.variantId}#${Number(item.quantity)}#${isIncluded}`,
        ],
        c_priceIncluded: isIncluded,
        c_list_price: item?.skuInfo?.listPrice || 0,
        c_itemTcpBossCategoryDisabled: bossDisabledFlags?.bossCategoryDisabled.toString(),
        c_itemTcpBossProductDisabled: bossDisabledFlags?.bossProductDisabled.toString(),
        c_seoToken: seoToken,
        c_isHardMarkEnabled: parseBoolean(hardMarkDown),
      };
    });
  if (accessoryItemArray) {
    queryPayload = {
      items: {
        itemList: [
          {
            cFromStoreId: params?.storeLocId,
            shipmentId: params?.pickupType.toUpperCase(),
            c_orderItemType: params?.pickupType.toUpperCase(),
            productId,
            quantity: Number(params?.quantity),
            c_prodPartNo: params?.productPartNo,
            c_brand: params?.brand || getBrandInCaps(),
            c_multiPack: !!params?.multipackCatentryId,
            c_multiPackItems: params?.multipackCatentryId,
            c_giftOption: false,
            c_giftItem: params?.giftItem,
            c_size: params?.size && params?.size.toString(),
            c_fit: params?.fit && params?.fit.toString(),
            c_TCPStyleType: params?.TCPStyleType || '',
            c_TCPStyleQTY: params?.TCPStyleQTY || '',
            c_TCPWebOnlyFlagStore: parseBoolean(params?.TCPWebOnlyFlagStore),
            c_TCPProductIndStore: params?.TCPProductIndStore,
            c_TCPColor: params?.productColor,
            c_TCPimages: params?.productUrl,
            c_variant: params?.variantNo,
            c_accessories: accessoryItemArray,
            c_bundlePromoId: formatPromotions(),
            c_customizationType: formatCustomizationType(customType),
            c_list_price: params?.listPrice,
            c_itemTcpBossCategoryDisabled: bossDisabledFlags?.bossCategoryDisabled.toString(),
            c_itemTcpBossProductDisabled: bossDisabledFlags?.bossProductDisabled.toString(),
            c_seoToken: seoToken,
            c_isHardMarkEnabled: parseBoolean(hardMarkDown),
          },
        ],
      },
    };
  }

  if (secondaryAccessoryItems && secondaryAccessoryItems?.length) {
    queryPayload = {
      items: {
        itemList: [...queryPayload.items.itemList, ...accessoryItems, ...secondaryAccessoryItems],
      },
    };
  } else if (accessoryItems && accessoryItems?.length) {
    queryPayload = {
      items: {
        itemList: [...queryPayload.items.itemList, ...accessoryItems],
      },
    };
  }
  // SFCC-TODO: Remove additional passed parameters(null, true)
  return executeStatefulGraphQLQuery({
    query: addStoreItemsMutation,
    variables: queryPayload,
    type: 'mutation',
    callbackParams,
    // context: { timeout: 2000 }, // example for timeout (in ms)
    updateQuery,
  })
    .then((response) => {
      let addToBasketResp = {};
      const { addStoreItems } = response?.data;
      if (response?.data && addStoreItems) {
        addToBasketResp = addStoreItems;
      } else if (responseContainsErrors({ res: { body: response } })) {
        throw new ServiceResponseError({ res: { body: response } });
      }
      const recentProduct = filterRecentlyAddedItem(
        addToBasketResp?.productItems,
        params?.itemPartNumber
      );
      return {
        orderItemId: addToBasketResp.productItems && recentProduct?.itemId,
        orderId: addToBasketResp.basketId,
        orderItems: addToBasketResp.productItems && formatOrderItems(addToBasketResp.productItems),
        estimatedRewards: 0,
        isBrierleyWorking: false,
        grandTotal: flatCurrencyToCents(addToBasketResp.productTotal),
        pointsToNextReward: addToBasketResp.pointsToNextReward || 0,
        totalItems: calculateTotalItems(addToBasketResp.productItems) || 0,
        giftCardsTotal: addToBasketResp.totalGiftCardAmount,
        earnedReward: addToBasketResp.earnedReward,
        cartTotalAfterPLCCDiscount: flatCurrencyToCents(
          addToBasketResp.c_cartTotalAfterPLCCDiscount || 0
        ), // need to come from SFCC // SFCC-TODO
        orderSubTotalDiscount: addToBasketResp.productSubTotal,
        loyaltyOrderItems: formProdItemsWithLoyaltyAttr(addToBasketResp, params),
        orderSubTotal: '',
        orderSubTotalBeforeDiscount: addToBasketResp.orderSubTotalBeforeDiscount,
        orderSubTotalWithoutGiftCard: addToBasketResp.orderSubTotalWithoutGiftCard,
        orderTotalAfterDiscount: '',
        orderTotalListPrice: '',
        orderTotalSaving: addToBasketResp.orderTotalSaving,
        mprId: '',
        loyaltyCallEnabled: false,
        pointsApi: '',
        ...getOrderTypes(addToBasketResp.productItems),
        basketId: addToBasketResp.basketId,
        addToBasketResp: {
          ...addToBasketResp,
          productItems: formProdItemsWithLoyaltyAttr(addToBasketResp, params),
        },
        bundleData: isBundleTracker
          ? formatBundleData(response, orderItems, bundleDataItems)
          : null,
      };
      // SFCC-TODO
    })
    .catch((err) => {
      throw graphQlErrorHandler(err, errorMapping);
    });
};

const getRequestPayloadForMultplipleItems = (paramsArray, isFromPjPlanner) => {
  const itemList = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const params of paramsArray) {
    const {
      productId,
      quantity,
      productPartNo,
      multipackCatentryId,
      giftItem,
      size,
      fit,
      TCPStyleType,
      TCPStyleQTY,
      productUrl,
      productColor,
      TCPWebOnlyFlagStore,
      TCPProductIndStore,
      variantNo,
      brand = '',
      listPrice,
      wasPrice,
      isExtendedPreOrder,
      seoToken,
    } = params;
    itemList.push({
      productId,
      quantity: Number(quantity),
      c_prodPartNo: productPartNo,
      c_brand: brand || getBrandInCaps(),
      c_multiPack: !!multipackCatentryId,
      c_multiPackItems: multipackCatentryId,
      c_giftOption: false,
      c_giftItem: giftItem,
      c_size: size,
      c_fit: fit,
      c_TCPStyleType: TCPStyleType || '',
      c_TCPStyleQTY: TCPStyleQTY || '',
      c_TCPWebOnlyFlagStore: parseBoolean(TCPWebOnlyFlagStore),
      c_TCPProductIndStore: TCPProductIndStore,
      c_TCPColor: productColor,
      c_TCPimages: productUrl,
      c_variant: variantNo,
      c_orderItemType: ORDER_ITEM_TYPE.ECOM,
      c_bundlePromoId: formatPromotions(),
      c_list_price: listPrice || wasPrice,
      c_seoToken: seoToken,
    });
    if (isExtendedPreOrder) {
      itemList[itemList.length - 1].isExtendedPreOrder = true;
    }
  }
  const addItemsToBasketItems = { partialAdd: isFromPjPlanner, itemList };
  return {
    addItemsToBasketItems,
  };
};

export const addMultipleProductsInEcomNEWAPI = (params, errorMapping, isFromPjPlanner) => {
  const reqObject = getRequestPayloadForMultplipleItems(params, isFromPjPlanner);
  const callbackParams = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const i of params) {
    callbackParams.push({
      LoyaltyPromoPLCCMultiplierStore: i.LoyaltyPromoMultiplierStore,
      LoyaltyPromoMultiplierStore: i.LoyaltyPromoMultiplierStore,
      productId: i.productId,
      preOrderDate: i.preOrderDate || '',
    });
  }
  // SFCC-TODO: Remove additional passed parameters(null, true)
  return executeStatefulGraphQLQuery({
    query: AddItemsInNewBasketMutation,
    variables: reqObject,
    type: 'mutation',
    callbackParams,
    updateQuery,
  })
    .then((response) => {
      let addToBasketResp = {};
      const { addItemsInNewBasket } = response.data;
      if (response.data && addItemsInNewBasket) {
        addToBasketResp = addItemsInNewBasket;
      } else if (responseContainsErrors({ res: { body: response } })) {
        throw new ServiceResponseError({ res: { body: response } });
      }
      return {
        basketId: addToBasketResp.basketId,
        orderId: addToBasketResp.basketId,
        basketError: addToBasketResp.basketError,
        orderItemId: addToBasketResp.basketId,
        orderTotal: addToBasketResp.productTotal,
        orderItemTotal: addToBasketResp.productTotal, // confirm mapping SFCC-TODO
        orderItems: addToBasketResp.productItems && formatOrderItems(addToBasketResp.productItems),
        estimatedRewards: 0,
        isBrierleyWorking: false,
        grandTotal: flatCurrencyToCents(addToBasketResp.productTotal),
        pointsToNextReward: addToBasketResp.pointsToNextReward || 0,
        totalItems: calculateTotalItems(addToBasketResp.productItems) || 0,
        giftCardsTotal: addToBasketResp.totalGiftCardAmount, // need to come from SFCC // SFCC-TODO
        earnedReward: addToBasketResp.earnedReward, // need to come from SFCC // SFCC-TODO
        cartTotalAfterPLCCDiscount: flatCurrencyToCents(
          addToBasketResp.c_cartTotalAfterPLCCDiscount || 0
        ), // need to come from SFCC // SFCC-TODO
        orderSubTotalDiscount: addToBasketResp.productSubTotal,
        loyaltyOrderItems: formProdItemsWithLoyaltyAttr(addToBasketResp, params),
        isElectiveBonus: '',
        orderSubTotal: '',
        orderSubTotalBeforeDiscount: addToBasketResp.orderSubTotalBeforeDiscount, // need to come from SFCC // SFCC-TODO
        orderSubTotalWithoutGiftCard: addToBasketResp.orderSubTotalWithoutGiftCard, // need to come from SFCC // SFCC-TODO
        orderTotalAfterDiscount: '',
        orderTotalListPrice: '',
        orderTotalSaving: addToBasketResp.orderTotalSaving, // need to come from SFCC // SFCC-TODO
        mprId: '',
        loyaltyCallEnabled: false,
        pointsApi: '',
        ...getOrderTypes(addToBasketResp.productItems), // in product item, orderItemType attribute not available // SFCC-TODO
        addToBasketResp: {
          ...addToBasketResp,
          productItems: formProdItemsWithLoyaltyAttr(addToBasketResp, params),
        }, // this resp is returned to update cart.
      };
    })
    .catch((err) => {
      // eslint-disable-next-line no-throw-literal
      throw {
        error: err,
      };
    });
};

export default {
  addCartEcomItem,
  addMultipleProductsInEcom,
  addCartBopisItem,
  addMultipleProductsInEcomNEWAPI,
  setPriceIncluded,
  findParentOfSecondaryAccessory,
  findSecondaryAccessoryId,
};
